import React from "react";
import { useNavigate } from "react-router-dom";
import { Photo } from "./Photo";
import { StatusBadge, DeadlineBadge } from "./StatusBadge";
import { fmtDate } from "../lib/dates";

export function JobCard({ job, basePath }) {
  const navigate = useNavigate();
  return (
    <div
      data-testid="job-card-item"
      onClick={() => navigate(`${basePath}/${job.id}`)}
      className="fadeup bg-white rounded-2xl border border-slate-200 shadow-sm overflow-hidden active:scale-[0.99] transition-transform cursor-pointer"
    >
      <div className="relative">
        <Photo src={job.photo} className="h-44 w-full" />
        <div className="absolute top-3 left-3">
          <StatusBadge status={job.status} />
        </div>
        <div className="absolute bottom-3 left-3 bg-black/55 backdrop-blur-sm rounded-lg px-2.5 py-1">
          <span className="tnum text-white text-xs font-bold">{job.job_number}</span>
        </div>
      </div>
      <div className="p-4 space-y-3">
        <div className="flex items-start justify-between gap-2">
          <h3 className="font-display text-xl font-bold text-slate-900 leading-tight">{job.product_name}</h3>
          {job.product_type && (
            <span data-testid="job-card-product-type" className="flex-shrink-0 text-[10px] font-bold uppercase tracking-wide text-[#9A462B] bg-[#F9EFEA] border border-[#E6A893] rounded-md px-2 py-0.5 mt-1">{job.product_type}</span>
          )}
        </div>

        <div className="flex items-end justify-between">
          <div>
            <p className="tnum text-3xl font-black text-slate-900 leading-none">{job.quantity}</p>
            <p className="text-[10px] font-bold uppercase tracking-wide text-slate-400 mt-1">Pieces</p>
            {job.status === "COMPLETED" && job.received_quantity != null && (
              <p data-testid="job-card-received" className="text-xs font-bold text-emerald-600 mt-1">Received: {job.received_quantity} pcs</p>
            )}
          </div>
          <div className="text-right">
            <p className="text-[10px] font-bold uppercase tracking-wide text-slate-400">Deadline</p>
            <p className="tnum text-lg font-bold text-slate-800">{fmtDate(job.deadline)}</p>
          </div>
        </div>

        <div className="flex items-center justify-between pt-1">
          <div className="flex items-center gap-2.5 flex-wrap">
            {job.sample_provided ? (
              <span className="text-xs font-bold text-emerald-600">✅ Sample</span>
            ) : (
              <span className="text-xs font-semibold text-slate-300">No sample</span>
            )}
            {job.with_earrings ? (
              <span data-testid="job-card-earrings" className="text-xs font-bold text-emerald-600">✅ Earrings</span>
            ) : (
              <span className="text-xs font-semibold text-slate-300">No earrings</span>
            )}
          </div>
          <DeadlineBadge job={job} />
        </div>
      </div>
    </div>
  );
}
